import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { useCustomerAuthStore } from '../lib/customerAuthStore.js';

export function RequireCustomerAuth({ children }: { children: ReactNode }): JSX.Element {
  const token = useCustomerAuthStore((s) => s.accessToken);
  const location = useLocation();
  if (!token) {
    return <Navigate to="/portal/login" state={{ from: location }} replace />;
  }
  return <>{children}</>;
}
